module.exports = __webpack_public_path__ + "img/s1_SNB.c1f399c3.svg";